import React, { useEffect } from 'react';
import { OktaAuth } from '@okta/okta-auth-js';
import config from '../../config';
const authClient2 = new OktaAuth(config.admin);

const EssilorAdminAuth = () => {
    useEffect(() => {
        console.log('config.admin.idp => ', config.admin.idp);
        authClient2.token.getWithRedirect({
            clientId: config.admin.clientId,
            responseType: ['id_token', 'token'],
            redirectUri: window.location.origin + '/idp',
            scopes: config.admin.scopes,
            state: '210eea7a-5a30-4b06-ade3-25214a10f6aa',
            nonce: '4d8a9814-d44c-4587-8c67-ebbb33749437',
            idp: config.admin.idp,
          });
    }, [])
    return (
        <div>...Loading</div>
    );
};

export default EssilorAdminAuth;
